var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from 'react';
import { getFocusStyles, getVariantStyles } from '../V2Button/styles';
import { baseStyles, shapeStyles, sizeStyles } from './styles';
function IconButtonComponent(props, ref) {
    const { component, children, variant = 'primary', size = 'medium', color = 'blue', shape = 'square', label, isSelected = false, disabled = false, type } = props, componentProps = __rest(props, ["component", "children", "variant", "size", "color", "shape", "label", "isSelected", "disabled", "type"]);
    const Component = component || 'button';
    const buttonProps = {};
    if (Component === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    }
    else {
        if (disabled) {
            buttonProps['aria-disabled'] = disabled;
        }
    }
    return (_jsx(Component, Object.assign({ ref: ref, "aria-label": label, css: [
            baseStyles,
            getFocusStyles(color, variant),
            sizeStyles[size],
            shapeStyles[shape],
            getVariantStyles(variant, color, isSelected),
        ], "data-disabled": disabled || undefined, tabIndex: disabled ? -1 : 0 }, buttonProps, componentProps, { children: children })));
}
/**
 * A component that renders an icon within a button
 *
 * @example
 *<IconButton label='Click me'><ForwardIcon /></IconButton>
 *
 */
export const IconButton = React.forwardRef(IconButtonComponent);
